// extracted by mini-css-extract-plugin
export default {"goTop":"GoTop_goTop__esXqS"};